import { ApiGateWay } from '../../ApiGateWay/ApiGateWay';
import { Config } from '../../config/config';
import React from 'react';
import axios from 'axios';
import Cookie from 'js-cookie';
import ArchiveDialog from './Dialogs/ArchiveDialog';
import IconButton from '@mui/material/IconButton';

const config = JSON.parse(Config);

async function fileDownload(documentPath) {
  //alert(documentPath);
  let headers = {
    Authorization: 'Bearer ' + JSON.parse(Cookie.get('token')),
    'Access-Control-Allow-Origin': '*',
    'x-api-key': process.env.REACT_APP_X_API_KEY,
  };
  axios
    .get(
      process.env.REACT_APP_UPLOAD_DOWNLOAD +
        config['api'] +
        '/download?objectId=' +
        documentPath,
      {
        headers: headers,
        responseType: 'blob',
      }
    )
    .then((response) => {
      //Create a Blob from the PDF Stream

      var re = /(?:\.([^.]+))?$/;

      var ext = re.exec(documentPath)[1]; // "txt"
      const MimeTypesMap = {
        png: 'image/png',
        gif: 'image/gif',
        jpg: 'image/jpg',
        jpeg: 'image/jpeg',
        pdf: 'application/pdf',
        mp4: 'video/mp4',
        doc: 'application/msword',
        docx:
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        ppt: 'application/vnd.ms-powerpoint',
        pptx: 'application/vnd.ms-powerpoint',
        xlsx:
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      };

      const mimeType = MimeTypesMap[ext];

      const file = new Blob([response.data], { type: mimeType });
      //Build a URL from the file
      const fileURL = URL.createObjectURL(file);
      //Open the URL on new Window
      if (mimeType === 'application/pdf') {
        window.open(fileURL, '_blank');
      } else {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', documentPath); //or any other extension
        document.body.appendChild(link);
        link.click();
      }
    })
    .catch((error) => {});
}

function dateFormat(d) {
  let date = new Date(d);
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let dt = date.getDate();
  let fDate = '';
  if (dt < 10) {
    dt = '0' + dt;
  }
  if (month < 10) {
    month = '0' + month;
  }
  fDate = dt + '-' + month + '-' + year;
  return fDate;
}

export const COMPLIANCE_DOCUMENTS = async (url, storeId) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] + url + '?storeId=' + storeId
  )
    .then((response) => response.json())
    .then((response) => {
      let body = [];
      let colorCodes = [];
      let proxyjson = [];
      let exp;
      let status = response.compliance[0].score;
      response.compliance[0].documentTypes.map((name, val) => {
        exp = name.expiryDate;
        if (name.documentStatus === 'Yes') {
          body.push([
            val + 1,
            <a
              onClick={() => fileDownload(name.documentPath)}
              style={{ cursor: 'pointer' }}
            >
              {name.documentType}
            </a>,
            exp,
            name.documentStatus,
            <ArchiveDialog
              url='/loadComplianceListArchive'
              storeId={storeId}
              documentId={name.documentTypeId}
            />,
            <IconButton
              onClick={() => handleDelete(name.documentId, 0)}
              style={{ color: ' #a94442' }}
            >
              <i className='fas fa-trash'></i>
            </IconButton>,
          ]);
        } else
          body.push([
            val + 1,
            name.documentType,
            exp,
            name.documentStatus,
            <ArchiveDialog
              url='/loadComplianceListArchive'
              storeId={storeId}
              documentId={name.documentTypeId}
            />,
            '',
          ]);
        colorCodes.push([0, 0, 0, 0, 0, 0]);
      });
      return (proxyjson = {
        type: 'Compliance',
        thead: [
          'SlNo',
          'Document Name',
          'Expiry Date',
          'Document Status',
          'Archive',
          'Delete',
        ],
        tbody: body,
        columns: [
          'SlNo',
          'Document Name',
          'Expiry Date',
          'Document Status',
          'Archive',
          'Delete',
        ],
        colorCodes: colorCodes,
        status: status,
      });
    });
  return fetchedData;
};

export const CONTRACT_DOCUMENTS = async (url, storeId) => {
  const fetchedData = await ApiGateWay.Get(
    config['api'] + url + '?storeId=' + storeId
  )
    .then((response) => response.json())
    .then((response) => {
      let body = [];
      let colorCodes = [];
      let proxyjson = [];
      let sDate;
      let eDate;
      let status = response.contracts[0].score;
      response.contracts[0].documentTypes.map((name, val) => {
        sDate = name.startDate;
        eDate = name.expiryDate;
        if (name.documentStatus === 'Yes') {
          body.push([
            val + 1,
            <a
              onClick={() => fileDownload(name.documentPath)}
              style={{ cursor: 'pointer' }}
            >
              {name.documentType}
            </a>,
            name.documentStatus,
            name.vendorName,
            sDate,
            eDate,
            <ArchiveDialog
              url='/loadContractListArchive'
              storeId={storeId}
              documentId={name.documentTypeId}
            />,
            <IconButton
              onClick={() => handleDelete(name.documentId, 1)}
              style={{ color: ' #a94442' }}
            >
              <i className='fas fa-trash'></i>
            </IconButton>,
          ]);
        } else
          body.push([
            val + 1,
            name.documentType,
            name.documentStatus,
            name.vendorName,
            sDate,
            eDate,
            <ArchiveDialog
              url='/loadContractListArchive'
              storeId={storeId}
              documentId={name.documentTypeId}
            />,
            '',
          ]);
        colorCodes.push([0, 0, 0, 0, 0, 0]);
      });
      return (proxyjson = {
        type: 'Contracts',
        thead: [
          'SlNo',
          'Document Name',
          'Document Status',
          'Vendor Name',
          'Contract Start Date',
          'Expiry Date',
          'Archive',
          'Delete',
        ],
        tbody: body,
        columns: [
          'SlNo',
          'Document Name',
          'Document Status',
          'Vendor Name',
          'Contract Start Date',
          'Expiry Date',
          'Archive',
          'Delete',
        ],
        colorCodes: colorCodes,
        status: status,
      });
    });
  return fetchedData;
};

function handleDelete(documentId, index) {
  if (index === 0) {
    ApiGateWay.Post(
      config['api'] + '/deleteComplianceDocument?documentId=' + documentId
    )
      .then((response) => {
        //

        window.location.reload();
      })
      .catch((error) => {});
  } else if (index === 1) {
    ApiGateWay.Post(
      config['api'] + '/deleteContractDocument?documentId=' + documentId
    )
      .then((response) => {
        //
        window.location.reload();
      })
      .catch((error) => {});
  }
}

export const SAVE_COMPLIANCE = async (url, maintenanceModel) => {
  const fetchedData = await ApiGateWay.Post(
    config['api'] + url,
    maintenanceModel
  )
    .then((response) => response.json())
    .then((response) => {})
    .catch((error) => {
      //
      this.setState({
        loading: false,
        modalOpen: true,
        message: 'Please try gain after some time',
      });
    });

  return fetchedData;
};

export const SAVE_CONTRACTS = async (url, maintenanceModel) => {
  const fetchedData = await ApiGateWay.Post(
    config['api'] + url,
    maintenanceModel
  )
    .then((response) => response.json())
    .then((response) => {
      //
    })
    .catch((error) => {
      //
      this.setState({
        loading: false,
        modalOpen: true,
        message: 'Please try gain after some time',
      });
    });

  return fetchedData;
};
